<template>
  <div id="app">
    <TerminalWindow />
    <BackgroundMatrix />
    <HeroSection />

    <FloatingChat />

    <SectionHeader />
    <OfficialDocuments />
    <!-- <ProfessionalBadges /> -->

    <HeroHeader />
    <ServiceCards />

    <HeroSectionF />
    <FeaturesSection />

    <SectionHeaderF />
    <TeamSection />

    <TestimonialsSection />

    <FaqHeader />
    <FaqTabs :currentTab="activeTab" @change-tab="activeTab = $event" />
    <FaqList :activeTab="activeTab" />

    <ContactSection />
  </div>
</template>

<script>
// @ is an alias to /src
import HeroSection from '../components/Home/SectionOne/HeroSection.vue';
import BackgroundMatrix from '../components/Home/SectionOne/BackgroundMatrix.vue';

import FloatingChat from '../components/FloatingChat.vue';

import SectionHeader from '../components/Home/SectionTwo/SectionHeader.vue';
import OfficialDocuments from '../components/Home/SectionTwo/OfficialDocuments.vue';
import ProfessionalBadges from '../components/Home/SectionTwo/ProfessionalBadges.vue';

import HeroHeader from '../components/Home/SectionThree/HeroHeader.vue';
import ServiceCards from '../components/Home/SectionThree/ServiceCards.vue';

import HeroSectionF from '@/components/Home/SectionFour/HeroSection.vue';
import FeaturesSection from '@/components/Home/SectionFour/FeaturesSection.vue';

import SectionHeaderF from '@/components/Home/SectionFive/SectionHeader.vue';
import TeamSection from '@/components/Home/SectionFive/TeamSection.vue';

import TestimonialsSection from '@/components/Home/SectionSix/TestimonialsSection.vue';

import FaqHeader from '@/components/Home/SectionSeven/FaqHeader.vue';
import FaqTabs from '@/components/Home/SectionSeven/FaqTabs.vue';
import FaqList from '@/components/Home/SectionSeven/FaqList.vue';

import ContactSection from '@/components/Home/SectionEight/ContactSection.vue';

export default {
  name: 'Home',
  components: {
    HeroSection,
    BackgroundMatrix,
    FloatingChat,
    SectionHeader,
    OfficialDocuments,
    ProfessionalBadges,
    HeroHeader,
    ServiceCards,
    HeroSectionF,
    FeaturesSection,
    SectionHeaderF,
    TeamSection,
    TestimonialsSection,
    FaqHeader,
    FaqTabs,
    FaqList,
    ContactSection,
  },
  data() {
    return {
      activeTab: 'General' // 当前选中的 Tab
    };
  }
}
</script>